module.exports = __webpack_public_path__ + "img/plan_biotope.c3cc0034.jpg";